export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=61594016631049",
  tiktok: "https://www.tiktok.com/@umi_speaks",
  youtube: "https://www.youtube.com/@umi_speaks",
};

export const CONTACT_EMAIL = "info@umispeaks.life";

export const IMAGES = {
  hero: "https://customer-assets-lxgj4vgw.emergentagent.net/job_ce64d4a2-b262-4928-8527-9cc7e75a6a46/artifacts/2o0ypjsk_5FC1C5FD-F0CE-43FD-A112-37569E950581.webp",
  portrait: "https://customer-assets-gfyr7b9c.emergentagent.net/job_umi-speaks/artifacts/larm6nca_14B00AB8-D3A0-4E62-8946-EF05D8A00B0A_1_105_c.jpeg",
  deck: "https://customer-assets-gfyr7b9c.emergentagent.net/job_umi-speaks/artifacts/7xeaymdn_IMG_2779.webp",
  candle: "https://images.unsplash.com/photo-1501471984908-815b996862f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjYW5kbGVsaWdodCUyMGRhcmt8ZW58MHx8fHwxNzg4MTQyMzI4fDA&ixlib=rb-4.1.0&q=85",
};
